import createReactComponent from '../createReactComponent';
export default createReactComponent('device-usb', 'IconDeviceUsb', [
  [
    'path',
    { d: 'M8 8h8v9a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-9z', key: 'svg-0' },
  ],
  ['path', { d: 'M10 8v-4h4v4', key: 'svg-1' }],
]);
